import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

export interface Workspace {
  id: string;
  company_id: string;
  name: string;
  inbox_alias: string;
  base_currency: string;
  created_at: string;
}

export function useWorkspaces() {
  return useQuery<Workspace[]>({
    queryKey: ['workspaces'],
    queryFn: async () => {
      const r = await api.get<Workspace[]>('/workspaces');
      return r.data;
    },
  });
}

export function useWorkspace(id: string | undefined) {
  return useQuery<Workspace>({
    queryKey: ['workspace', id],
    enabled: !!id,
    queryFn: async () => {
      const r = await api.get<Workspace>(`/workspaces/${id}`);
      return r.data;
    },
  });
}
